import type { paths } from '@pba/types-openapi-node';
import type { BodyRouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type UpdateEventParticipantBodyRequestParams =
  paths['/events/{eventId}/participants/{participantId}']['patch']['requestBody']['content']['application/json'];
type UpdateEventParticipantPathRequestParams =
  paths['/events/{eventId}/participants/{participantId}']['patch']['parameters']['path'];

export const updateEventParticipant = async ({
  body,
  routeParams: { eventId, participantId },
}: BodyRouteParamsRequest<UpdateEventParticipantBodyRequestParams, UpdateEventParticipantPathRequestParams>) =>
  nodeApiClient.patch<unknown, ApiClientResponse<unknown>>(
    nodeApiRoutes.events.participants.update(eventId, participantId),
    body,
  );
